export function transformCurrentSessionSecurity(security) {
  var _currentSession$centr, _currentSession$centr2;
  var currentSession = security.current_session;
  return {
    applicationRoles: currentSession.application_roles || [],
    applicationPermissions: currentSession.application_permissions || [],
    centralizedSession: {
      centralizedUserId: currentSession.centralized_session.centralized_user_id,
      centralizedOrganizationId: currentSession.centralized_session.centralized_organization_id,
      centralizedOrganizationSlug: currentSession.centralized_session.centralized_organization_slug,
      centralizedUserOrganizationId: currentSession.centralized_session.centralized_user_organization_id,
      centralizedUserOrganizationRole: currentSession.centralized_session.centralized_user_organization_role,
      centralizedUserCountryCode: (_currentSession$centr = currentSession === null || currentSession === void 0 ? void 0 : (_currentSession$centr2 = currentSession.centralized_session) === null || _currentSession$centr2 === void 0 ? void 0 : _currentSession$centr2.centralized_user_country_code) !== null && _currentSession$centr !== void 0 ? _currentSession$centr : undefined
    },
    talentSession: currentSession !== null && currentSession !== void 0 && currentSession.talent_session ? {
      companyId: currentSession.talent_session.company_id,
      employeeId: currentSession.talent_session.employee_id,
      userId: currentSession.talent_session.user_id,
      userRole: currentSession.talent_session.user_role
    } : undefined,
    learningSession: currentSession !== null && currentSession !== void 0 && currentSession.learning_session ? {
      userId: currentSession.learning_session.user_id,
      organizationId: currentSession.learning_session.organization_id,
      organizationSlug: currentSession.learning_session.organization_slug,
      userOrganizationId: currentSession.learning_session.user_organization_id,
      userOrganizationRole: currentSession.learning_session.user_organization_role
    } : undefined
  };
}